import axios, { AxiosResponse } from "axios";
import { Candidate } from "../../models";

const apiClient = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

export const searchCandidates = async (searchString: string) => {
  const trimmedSearchInput = searchString.trim();
  try {
    const achrmresponse = await apiClient.get(`/candidate`, {
      baseURL: baseUrl(),
      params: { q: trimmedSearchInput },
    });

    const mhrsdresponse = await apiClient.get(`/mhrsd/candidates`, {
      baseURL: baseUrl(),
      params: { q: trimmedSearchInput },
    });

    const ntucLearningHubResponse = await apiClient.get(
      `/ntuc-learning-hub/candidates`,
      {
        baseURL: baseUrl(),
        params: { q: trimmedSearchInput },
      },
    );

    const apacResponse = await apiClient.get(`/apac/candidates`, {
      baseURL: baseUrl(),
      params: { q: trimmedSearchInput },
    });

    const specialtyCredentialsResponse = await apiClient.get(
      `/specialty-credentials/candidates`,
      {
        baseURL: baseUrl(),
        params: { q: trimmedSearchInput },
      },
    );

    const indiaResponse = await apiClient.get(`/india/candidates`, {
      baseURL: baseUrl(),
      params: { q: trimmedSearchInput },
    });

    const aihrResponse = await apiClient.get(`/aihr/candidates`, {
      baseURL: baseUrl(),
      params: { q: trimmedSearchInput },
    });

    const aceResponse = await apiClient.get(`/ace/candidates`, {
      baseURL: baseUrl(),
      params: { q: trimmedSearchInput },
    });

    return {
      data: [
        ...achrmresponse.data,
        ...mhrsdresponse.data,
        ...ntucLearningHubResponse.data,
        ...apacResponse.data,
        ...specialtyCredentialsResponse.data,
        ...indiaResponse.data,
        ...aihrResponse.data,
        ...aceResponse.data,
      ],
      error: null,
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    return { data: null, error };
  }
};

export const searchOldCertificates = async (
  studentId: string,
  certificateNo: string,
) => {
  try {
    const achrmresponse = await apiClient.get(`/candidate`, {
      baseURL: baseUrl(),
      params: { q: studentId },
    });
    const filteredCertificate = achrmresponse.data.find(
      (cand: Candidate) => cand.certNo === certificateNo,
    );
    return {
      data: [...filteredCertificate.data],
      error: null,
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    return { data: null, error };
  }
};

export const retrieveCertificate = async (
  candidateId: string,
  certId: string,
) => {
  try {
    const fetchFirst = fetch(
      baseUrl() +
        (candidateId
          ? `/candidates/${candidateId}/certificates/${certId}`
          : `/certificates/${certId}`),
    );

    const fetchSecond = fetch(
      baseUrl() +
        (candidateId
          ? `/mhrsd/candidates/${candidateId}/certificates/${certId}`
          : `/mhrsd/certificates/${certId}`),
    );
    const fetchThird = fetch(
      baseUrl() +
        (candidateId
          ? `/ntuc-learning-hub/candidates/${candidateId}/certificates/${certId}`
          : `/ntuc-learning-hub/certificates/${certId}`),
    );
    const fetchFourth = fetch(
      baseUrl() +
        (candidateId
          ? `/apac/candidates/${candidateId}/certificates/${certId}`
          : `/apac/certificates/${certId}`),
    );
    const fetchFifth = fetch(
      baseUrl() +
        (candidateId
          ? `/specialty-credentials/candidates/${candidateId}/certificates/${certId}`
          : `/specialty-credentials/certificates/${certId}`),
    );
    const fetchSixth = fetch(
      baseUrl() +
        (candidateId
          ? `/india/candidates/${candidateId}/certificates/${certId}`
          : `/india/certificates/${certId}`),
    );
    const fetchSeventh = fetch(
      baseUrl() +
        (candidateId
          ? `/aihr/candidates/${candidateId}/certificates/${certId}`
          : `/aihr/certificates/${certId}`),
    );
    const fetchEighth = fetch(
      baseUrl() +
        (candidateId
          ? `/ace/candidates/${candidateId}/certificates/${certId}`
          : `/ace/certificates/${certId}`),
    );

    console.log(fetchSeventh);

    const results = await Promise.allSettled([
      fetchFirst,
      fetchSecond,
      fetchThird,
      fetchFourth,
      fetchFifth,
      fetchSixth,
      fetchSeventh,
      fetchEighth,
    ]);
    // Check which promise succeeded
    const successfulResponse = results.find(
      (result) =>
        result.status === "fulfilled" &&
        (result as PromiseFulfilledResult<Response>).value.status === 200,
    );
    if (successfulResponse) {
      return {
        data: await (
          successfulResponse as PromiseFulfilledResult<Response>
        ).value.json(),
        error: null,
      };
    } else {
      return { data: null, error: new Error("Network response was not ok") };
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return { data: null, error };
  }
};

export const baseUrl = () => {
  return (window as any).config?.REACT_APP_API_BASE_URL;
};
